import {define, type, attr, Record} from 'type-r';

@define
class AccrualModel extends Record {
    @attr accrual_type: string;
    @attr accrual_type_id: string;
    @attr amount: string;
    @type(Date).as upload_date: Date;
    @attr plot: number;
}

export default AccrualModel;


// WEBPACK FOOTER //
// ./src/models/AccrualModel.ts